<div
  *ngIf="vop_requests.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="vop_requests"
    class="sp-width__full">
    <ng-container matColumnDef="vop_request_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'VOP_REQUEST.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <app-shared-id
          [content]="vop_request.vop_request_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'VOP_REQUEST.CREATEDA_AT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <span class="sp-color__primary sp-text__ellipsized"> {{ vop_request.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'VOP_REQUEST.STATUS_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <div class="sp-row__align">
          <div
            class="sp-circle__xs sp-margin__right"
            [matTooltip]="getVopRequestStatusLabel(vop_request) | translate"
            [ngClass]="getVopRequestStatusBackgroundClass(vop_request)"></div>
          <h5 class="sp-color__primary sp-text__ellipsized">{{ getVopRequestStatusLabel(vop_request) | translate }}</h5>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="result">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'VOP_REQUEST.RESULT' | translate }} </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ getVopRequestResultLabel(vop_request) | translate }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="similiarity_score">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'VOP_REQUEST.SIMILIARITY_SCORE' | translate }} </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ vop_request.similiarity_score || 0 | number : '0.2-2' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="most_similar_call">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'VOP_REQUEST.MOST_SIMILAR_CALL' | translate }} </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ getVopRequestMostSimilarCallLabel(vop_request) | translate }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="beneficiary_firstname">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'VOP_REQUEST.BENEFICIARY_FIRSTNAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <span
          *ngIf="vop_request.beneficiary_firstname"
          class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{
            vop_request.beneficiary_firstname?.length > 30
              ? (vop_request.beneficiary_firstname | slice : 0 : 30) + '...'
              : vop_request.beneficiary_firstname
          }}
        </span>
        <span *ngIf="!vop_request.beneficiary_firstname"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="beneficiary_lastname">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'VOP_REQUEST.BENEFICIARY_LASTNAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <span
          *ngIf="vop_request.beneficiary_lastname"
          class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{
            vop_request.beneficiary_lastname?.length > 30
              ? (vop_request.beneficiary_lastname | slice : 0 : 30) + '...'
              : vop_request.beneficiary_lastname
          }}
        </span>
        <span *ngIf="!vop_request.beneficiary_lastname"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="beneficiary_tax_code">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'VOP_REQUEST.BENEFICIARY_TAX_CODE_LABEL' | translate }} </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <span class="sp-color__primary sp-text__ellipsized"> {{ vop_request.beneficiary_tax_code || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="beneficiary_iban">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'VOP_REQUEST.BENEFICIARY_IBAN' | translate }} </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <span class="sp-color__primary sp-text__ellipsized"> {{ vop_request.beneficiary_iban || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="buyer_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'VOP_REQUEST.BUYER_ID' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <app-shared-id
          [content]="vop_request.buyer_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="order_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'VOP_REQUEST.ORDER_ID' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <app-shared-id
          [content]="vop_request.order_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'VOP_REQUEST.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let vop_request">
        <div class="sp-row__align">
          <button
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'GENERAL.SEE_REQUESTS_CTA' | translate"
            [disabled]="!vop_request.fl_call && !vop_request.lf_call && !vop_request.tax_code"
            (click)="onDetailsClick(vop_request)">
            <mat-icon class="material-symbols-outlined"> list </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      class="sp-cursor__pointer"
      *matRowDef="let row; columns: displayed_columns"></tr>
  </table>
</div>
